import React, { useState,useEffect } from "react";
import { toast } from 'react-toastify';
import ColorPicker from "../../../components/ColorPicker";
import CssCodeEditor from "../../../components/CssCodeEditor";
import JsCodeEditor from "../../../components/JsCodeEditor";

const AppearanceTab = ({ updateWhatsAppTabData,whatsAppTabData }) => {
    const [bubbleBackgroundColor, setBubbleBackgroundColor] = useState(whatsAppTabData.appearance_bubble_background_color);
    const [bubbleIconColor, setBubbleIconColor] = useState(whatsAppTabData.appearance_bubble_icon_color);
    const [bubbleNotificationBadgeColor, setbubbleNotificationBadgeColor] = useState(whatsAppTabData.appearance_bubble_notification_badge_color);
    const [headerBackgroundColor, setHeaderBackgroundColor] = useState(whatsAppTabData.appearance_header_background_color);
    const [userOnlineStatusColor, setUserOnlineStatusColor] = useState(whatsAppTabData.appearance_user_online_status_color);
    //const [chatWallpaper, setchatWallpaper] = useState("#4D4D4F");
    const [messageBackgroundColor, setMessageBackgroundColor] = useState(whatsAppTabData.appearance_message_background_color);
    const [messageFieldColor, setMessageFieldColor] = useState(whatsAppTabData.appearance_message_field_color);
    //const [sendMessageButtonColor, setSendMessageButtonColor] = useState(whatsAppTabData.appearance_button_color);
    const [activeAppearanceElementsTab, setActiveAppearanceElementsTab] = useState("main");
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(whatsAppTabData.appearance_custom_css);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(whatsAppTabData.appearance_custom_js);
    
    //Button Animation
    /*const [isButtonAnimationToggleEnabled, setIsEnableButtonAnimationEnabled] = useState(false);
    const setingEnableAnimationIntervalRef = useRef(null);
    useEffect(() => {
        const checkbox = setingEnableAnimationIntervalRef.current;
        if (checkbox) {
            setIsEnableButtonAnimationEnabled(checkbox.checked);
        }
    }, []);
    const handleEnableButtonAnimationToggle = () => {
        setIsEnableButtonAnimationEnabled(setingEnableAnimationIntervalRef.current.checked);
    };*/

    //Animation interval Sec
   /* const [selectedAnimationintervalSec, setSelectedAnimationintervalSec] = useState(20);
    const [showAnimationintervalSecDropdown, setShowAnimationintervalSecDropdown] = useState(false);
    const layoutAnimationintervalSecValues = [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 30, 40, 50];
    const toggleAnimationintervalSecDropdown = () => {
        setShowAnimationintervalSecDropdown(!showAnimationintervalSecDropdown);
    };
    const handleAnimationintervalSecSelect = (spacing) => {
        setSelectedAnimationintervalSec(spacing);
        setShowAnimationintervalSecDropdown(false);
    };*/

    // Handlers Bubble Background Color Change
    const handleBubbleBackgroundColorChange = (color) => {
        setBubbleBackgroundColor(color.hex);
        updateWhatsAppTabData("appearance_bubble_background_color", color.hex);
    };

    // Handlers Bubble Icon Color Change
    const handleBubbleIconColorChange = (color) => {
        setBubbleIconColor(color.hex);
        updateWhatsAppTabData("appearance_bubble_icon_color", color.hex);
    };
    // Handlers Bubble Icon Color Change
    const handleBubbleNotificationBadgeColorChange = (color) => {
        setbubbleNotificationBadgeColor(color.hex);
        updateWhatsAppTabData("appearance_bubble_notification_badge_color", color.hex);
    };

    // Handlers Header Background Color Change
    const handleHeaderBackgroundColorChange = (color) => {
        setHeaderBackgroundColor(color.hex);
        updateWhatsAppTabData("appearance_header_background_color", color.hex);
    };


    // Handlers Header Background Color Change
    const handleUserOnlineStatusColorChange = (color) => {
        setUserOnlineStatusColor(color.hex);
        updateWhatsAppTabData("appearance_user_online_status_color", color.hex);
    };

    // Handlers Message Background Color Change
    const handleMessageBackgroundColorChange = (color) => {
        setMessageBackgroundColor(color.hex);
        updateWhatsAppTabData("appearance_message_background_color", color.hex);
    };

    // Handlers Message Field Color Change
    const handleMessageFieldColorChange = (color) => {
        setMessageFieldColor(color.hex);
        updateWhatsAppTabData("appearance_message_field_color", color.hex);
    };

    // Handlers Send Message Button Color Change
    /*const handleSendMessageButtonColorChange = (color) => {
        setSendMessageButtonColor(color.hex);
        updateWhatsAppTabData("appearance_button_color", color.hex);
    };*/

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateWhatsAppTabData("appearance_custom_css", code);
    };

    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateWhatsAppTabData("appearance_custom_js", code);
    };

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => {
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };

    return (
        <div className="whats-app-side-baar-appearance-tab">
            {activeAppearanceElementsTab === "main" && (
                <>
                <span>Appearance</span>
                <div className="side-baar-box-header">
                    <div className="box-header-row">
                        <span>Font</span>
                        <em>Default</em>
                    </div>
                    <div className="box-header-row">
                        <span>Bubble Background Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={bubbleBackgroundColor} setColor={setBubbleBackgroundColor} onChangeComplete={handleBubbleBackgroundColorChange} />
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Bubble Icon Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={bubbleIconColor} setColor={setBubbleIconColor} onChangeComplete={handleBubbleIconColorChange} />
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Bubble Notification Badge Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={bubbleNotificationBadgeColor} setColor={setbubbleNotificationBadgeColor} onChangeComplete={handleBubbleNotificationBadgeColorChange} />
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Header Background Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={headerBackgroundColor} setColor={setHeaderBackgroundColor} onChangeComplete={handleHeaderBackgroundColorChange} />
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>User Online Status Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={userOnlineStatusColor} setColor={setUserOnlineStatusColor} onChangeComplete={handleUserOnlineStatusColorChange}/>
                        </div>
                    </div>
                    {/*<div className="box-header-row">
                        <span>Chat Wallpaper</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={chatWallpaper} setColor={setchatWallpaper} />
                        </div>
                    </div>*/}
                    <div className="box-header-row">
                        <span>Message Background Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={messageBackgroundColor} setColor={setMessageBackgroundColor} onChangeComplete={handleMessageBackgroundColorChange}/>
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Message Field Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={messageFieldColor} setColor={setMessageFieldColor} onChangeComplete={handleMessageFieldColorChange}/>
                        </div>
                    </div>
                    {/*<div className="box-header-row">
                        <span>Send Message Button Color</span>
                        <div className="color-pikr-box">
                            <ColorPicker color={sendMessageButtonColor} setColor={setSendMessageButtonColor} onChangeComplete={handleSendMessageButtonColorChange}/>
                        </div>
                    </div>*/} 
                </div>
                {/*<div className="name-tile-row">Bubble Animation</div>
                <div className="side-baar-box-header">
                    <div className="box-header-row">
                        <span>Enable Animation</span>
                        <div className="form-group">
                            <input id="button_animation_toggle" className="chkbx-toggle" type="checkbox" value="1" ref={setingEnableAnimationIntervalRef} onChange={handleEnableButtonAnimationToggle} defaultChecked={true}/>
                            <label for="button_animation_toggle"></label>
                        </div>
                    </div>
                    {isButtonAnimationToggleEnabled && (
                        <div className="box-header-row">
                            <span>Animation Interval</span>
                            <em onClick={toggleAnimationintervalSecDropdown}>{selectedAnimationintervalSec}sec</em>
                            {showAnimationintervalSecDropdown && (
                                <ul className="dropdown-list">
                                    {layoutAnimationintervalSecValues.map((spacing) => (
                                        <li key={spacing} onClick={() => handleAnimationintervalSecSelect(spacing)}>
                                            {spacing}sec
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    )}
                </div>*/}
                <div className="side-baar-box-header">
                    <div className="box-header-row" onClick={() => setActiveAppearanceElementsTab("custom_css")}>
                        <span>Custom CSS</span>
                        <em><button><i className="fa fa-angle-right" aria-hidden="true"></i></button></em>
                    </div>
                    <div className="box-header-row" onClick={() => setActiveAppearanceElementsTab("custom_js")}>
                        <span>Custom JS</span>
                        <em><button><i className="fa fa-angle-right" aria-hidden="true"></i></button></em>
                    </div>
                </div>
                </>
            )}

            {activeAppearanceElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveAppearanceElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )}

            {activeAppearanceElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveAppearanceElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default AppearanceTab;